import MarkedShelf from '@components/storeMap/floor/2d/MarkedShelf'
import { getShelfColorByUnknownPercentage } from '@components/storeMap/utils'

import type { ShelfProps } from './Shelf'

function UnknownPercentageShelf({ shelf, ...props }: ShelfProps) {
  const fill = shelf.dayState === 'notCurrent'
    ? 'var(--color-shelf-neutral)'
    : shelf.statistics ? getShelfColorByUnknownPercentage(shelf.statistics.shareOfUnknownProducts) : undefined

  return (
    <MarkedShelf
      state='highlightPercentage'
      shelf={shelf}
      fill={fill}
      {...props}
    />
  )
}

export default UnknownPercentageShelf